<template>
  <!-- 这个是编辑项目的页面 -->
  <div class="contain">
    <!-- 这里边是标题和返回 -->
    <div class="title_box">
      <h4>{{ navigationTitle }}</h4>
      <el-button size="small" type="info" @click="backProject">返回</el-button>
    </div>
    <el-card class="box-card">
      <!-- 这里边是一个表单 -->
      <el-form ref="reference" :model="reference" size="small" label-width="80px" label-position="top" :rules="rules">
        <el-form-item label="共识题目" prop="name">
          <el-col>
            <el-input type="textarea" v-model="reference.name" placeholder="请输入共识题目"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="参会专家" prop="expert_id" required>
          <el-col :span="10">
            <el-select v-model="reference.expert_id" remote multiple filterable placeholder="参会专家">
              <el-option v-for="item in expertObject" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
              <!-- 这里边再加一个分页 -->
              <!-- <el-pagination
                style="text-align: center;"
                layout="prev, pager, next"
                @current-change="currentchange"
                @prev-click="prevClick"
                @next-click="nextClick"
                :current-page.sync="currentPage"
                hide-on-single-page
                :page-count="expertObject.pages"
              >
              </el-pagination> -->
            </el-select>
          </el-col>
        </el-form-item>
        <el-form-item label="执笔人" prop="writer">
          <el-col :span="19">
            <tags-input v-model="reference.writer" :defaulList="defaulList" :listFilter=true placeholder="按enter键创建标签"
              @tagClose="tagClose"></tags-input>
            <!-- <el-input
              type="text"
              v-model="reference.writer"
              placeholder="请输入执笔人"
              @keyup.enter.native="search"
            >
            </el-input> -->
          </el-col>
          <span class="ticks">可输入多个“执笔人”，按回车键完成输入确认</span>
        </el-form-item>
        <el-form-item label="共识投稿">
          <!-- 这里是附件-->
          <div class="uploads-box">
            <el-upload class="upload-demo" :action="action" multiple :file-list="fileListFJ"
              :on-success="accessorySuccess" :data="{ file: 'file', model: '' }" ref="accessory" v-model="reference.draft"
              :limit="1" :before-remove="beforeremove">
              <el-button size="small" type="info">选择文件</el-button>
              <div class="box"></div>
            </el-upload>
            <span class="ticks">请上传TXT、DOC、XLS、PPT、DOCX、XLSX、PPTX、PDF
              等文件格式</span>
          </div>
        </el-form-item>
        <el-form-item label="参考文献">
          <!-- 这里是代表性论文 -->
          <div class="uploads-box">
            <el-upload class="upload-demo" :action="action" multiple :file-list="fileListLW" :on-success="thesisSuccess"
              :data="{ file: 'file', model: '' }" ref="thesis" :limit="1" v-model="reference.reference"
              :before-remove="beforeremoveLW">
              <el-button size="small" type="info">选择文件</el-button>
              <div class="box"></div>
            </el-upload>
            <span class="ticks">请上传TXT、DOC、XLS、PPT、DOCX、XLSX、PPTX、PDF
              等文件格式</span>
          </div>
        </el-form-item>
        <el-form-item label="版本号">
          <el-col :span="6">
            <el-input v-model="reference.version" placeholder="请输入版本号"></el-input>
          </el-col>
        </el-form-item>
        <!-- 备注 -->
        <el-form-item label="备注">
          <el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="reference.remarks">
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" style="background: #484c7f" @click="submitForm('reference')">保存</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>
 
<script>
import TagsInput from '../../components/tagsInput/tagsInput.vue'
export default {
  name: 'editorProject',
  components: {
    TagsInput
  },
  data() {
    var validatePass = (rule, value, callback) => {
      if (value.length == 0) {
        callback(new Error('请选择参会专家'));
      } else {
        callback();
      }
    };
    return {
      tagList: null, //子组件返回的list
      defaulList: [], // 付默认值
      listFilter: false,// 是否去重
      navigationTitle: '录入共识撰写',
      expertObject: [],
      reference: {
        id: '',//主键id 有时修改 空时添加
        p_id: '',//项目id
        name: '',//共识题目
        expert_id: [],//牵头专家id
        writer: '',//执笔人
        reference_name: '',//参考文献名称
        reference: '',//参考文献
        draft_name: '',//共识投稿名称
        draft: '',//共识投稿 
        version: '',//版本
        remarks: '',//备注  
      },
      rules: {
        name: [
          { required: true, message: '请输入共识题目', trigger: 'blur' },
        ],
        expert_id: [
          { validator: validatePass, trigger: 'change' }
        ],
        writer: [
          { required: true, message: '请输入执笔人', trigger: 'blur' },
        ],
        // draft: [
        //   { required: true, message: '请上传共识投稿', trigger: 'change' },
        // ],
      },
      total: 0,//总条目数
      pagesize: 6,//每页显示条目个数
      currentPage: 1,//当前页数  
      action: `https://laravel.gongshicloud.com/api/index/upload`,
      imageUrl: "",
      fileListLW: [], //文献
      fileListFJ: [], //共识
    }
  },
  created() {
    if (this.$route.query.id != "") { this.editorConference(this.$route.query.id) } else { this.getProjectList() }
    if (this.$route.query.project_id != '' && this.$route.query.project_id != null && this.$route.query.project_id != undefined) this.reference.p_id = this.$route.query.project_id
    this.getExpertList()
  },
  methods: {
    //编辑进来的
    async editorConference(id) {
      this.navigationTitle = '编辑共识撰写'
      const { data: data } = await this.$http.post('gs/info', {
        id,
      })
      this.reference = data.data
      if (data.data.writer.length != 0) this.defaulList = data.data.writer
      if (data.data.reference_name != "") this.fileListLW.push({ name: data.data.reference_name, url: data.data.reference })
      if (data.data.draft_name != "") this.fileListFJ.push({ name: data.data.draft_name, url: data.data.draft })
    },
    // 标签关闭方法
    tagClose(tag) {
      console.log(tag)
    },
    //参会专家 获取专家列表
    async getExpertList() {
      const { data: data } = await this.$http.post('expert/all')
      this.expertObject = data.data
    },
    //项目列表参会专家
    async getProjectList() {
      const { data: data } = await this.$http.post('select/expert', { project_id: this.$route.query.project_id })
      this.reference.expert_id = data.data
    },
    //文献 
    thesisSuccess(res, file, fileList) {
      if (res.code != 200) {
        this.$message.error(res.message)
        this.$refs.thesis.clearFiles()
        return
      }
      this.$Loading.finish()
      this.reference.reference = res.data.url
      this.reference.reference_name = res.data.file_name
    },
    //删除文献
    beforeremoveLW(res, file, fileList) {
      this.reference.reference = ''
      this.reference.reference_name = ''
      this.fileListLW = []
    },
    //投稿
    accessorySuccess(res, file, fileList) {
      if (res.code != 200) {
        this.$message.error(res.message)
        this.$refs.accessory.clearFiles()
        return
      }
      this.$Loading.finish()
      this.reference.draft = res.data.url
      this.reference.draft_name = res.data.file_name
    },
    //删除投稿
    beforeremove(res, file, fileList) {
      this.reference.draft = ''
      this.reference.draft_name = ''
      this.fileList = []
    },
    // 滚动条定位到第一个校验失败的div的位置
    locateToErr() {
      setTimeout(() => {
        let errorDiv = document.getElementsByClassName('is-error')
        errorDiv[0].scrollIntoView()
      }, 0)
    },
    //执笔人 回车
    search(e) {
      var theEvent = window.event || e;
      var code = theEvent.keyCode || theEvent.which || theEvent.charCode;
      if (code == 13) {
        console.log(this.reference.writer);
      }
    },
    //点击提交表单 
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.reference.writer = this.reference.writer.map(item => item).join(',') //输入执笔人
          this.submitApi()
        } else {
          this.locateToErr()
          return false;
        }
      });
    },
    //提交表单api
    async submitApi() {
      const { data: data } = await this.$http.post('gs/add', this.reference)
      this.$message({
        message: data.message,
        type: 'success'
      });
      this.$router.back()
    },
    //点击每一页  
    currentchange(e) {
      this.currentPage = e
      this.getExpertList()
    },
    //上一页  
    prevClick(e) {
      this.currentPage = e
      this.getExpertList()
    },
    //下一页 
    nextClick(e) {
      this.currentPage = e
      this.getExpertList()
    },
    backProject() {
      this.$router.back()
    },
  }
}
</script>

<style lang='less' scoped>
.contain {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;

  .title_box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #e8e8e8;
    padding-bottom: 16px;
    margin-bottom: 23px;

    h4 {
      font-size: 28px;
      color: #212529;
    }
  }

  .box-card {
    width: 100%;
    flex: 1;
    overflow-y: auto;
  }

  /deep/.el-select {
    display: block;
  }

  //  上传文件样式
  .uploads {
    display: flex;

    .upload-demo {
      display: flex;

      // align-items: center;
      .el-button {
        border-radius: 6px 0 0 6px;
      }

      /deep/ .el-upload-list {
        border: 1px solid #f0f0f0;
        border-radius: 0 6px 6px 0;
        width: 421px;
        height: 32px;
        margin-top: 1px;

        .el-upload-list__item {
          margin: 3px 0;
        }
      }
    }
  }

  .box-card {
    width: 100%;
    flex: 1;
    // overflow-y: auto;
  }

  /deep/.el-select {
    display: block;
  }

  // 上传图片的样式
  /deep/ .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    width: 66px;
    height: 66px;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 30px;
    height: 30px;
    line-height: 66px;
    text-align: center;
  }

  .avatar {
    width: 66px;
    height: 66px;
    display: block;
  }

  // 上传图片样式结束

  /deep/ .el-card {
    overflow: visible;
  }

  .Penmanship {
    position: absolute;
    top: 9px;
    left: 315px;
    font-size: 12px;
    color: #cc0808;
  }

  .ticks {
    color: #cc0808;
    font-size: 12px;
    margin-top: 10px;
    margin-left: 13px;
  }

  //新的
  .uploads-box {
    position: relative;

    .upload-demo {
      align-items: center;

      .el-button {
        border-radius: 6px 0 0 6px;
      }

      .box {
        position: absolute;
        top: 1px;
        left: 80px;
        width: 421px;
        height: 32px;
        border: 1px solid #f0f0f0;
        border-radius: 0 6px 6px 0;
      }
    }

    .ticks {
      position: absolute;
      top: -10px;
      left: 500px;
      color: #cc0808;
      font-size: 12px;
      margin-top: 10px;
      margin-left: 13px;
    }
  }

  /deep/ .el-upload-list {
    z-index: 9999;
    position: absolute;
    top: -5px;
    left: 80px;
    width: 410px;
    overflow: hidden;
  }
}
</style>
